/* eslint-disable import/no-cycle */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useState, useEffect } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Dialog from '@material-ui/core/Dialog';
import Footer from '../../../../SharedModules/Layout/footer';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import { useDispatch, useSelector } from 'react-redux';
import {
  checkActionAccessByRole,
  PaperComponent,
} from '../../../../SharedModules/utilities/utilities';
import { dispatchSetOverride508Compliance } from '../store/actions';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
function UserDefaultForm(props) {
  const {
    handleCloseSave,
    openSave,
    open,
    handleClickOpenCancel,
    handleClickOpenSave,
    handleClose,
    checkPayeeCode,
    onCancel,
    sucessMessage,
    errorMessage,
    spinner,
    onSave,
    values,
    onChangeValuesHandler,
    rebateProgramCode,
    clientCode,
    planCode,
    groupCode,
    isUserChangedValue,
  } = props;
  const CHECK_BOX_VALUE_TO_BE_CHECKED = 1;
  const dispatch = useDispatch();
  const [showViewHistory, setShowViewHistory] = useState(false);
  const [keyValue, setKeyValue] = useState([]);
  const [remotePrinterIpAddrList, setRemotePrinterIpAddrList] = useState([]);

  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const [hasAccessbyRole, setHasAccessbyRole] = useState(
    checkActionAccessByRole(process.env.REACT_APP_OVERRIDE_ONLY_ROLE, kcRoles)
  );
  const is508NotReq = useSelector(
    (state) => state?.sharedState.UserDefaultReducer.override508Compliance
  );
  const [isEnablebyRole, setIsEnablebyRole] = useState(
    !checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );
  useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setHasAccessbyRole(
        checkActionAccessByRole(
          process.env.REACT_APP_HIDE_ACCESS_ROLES,
          kcRoles
        )
      );
      setIsEnablebyRole(
        !checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
    if (process.env.REACT_APP_PRINTER_IP_ADDRESS) {
      const list = process.env.REACT_APP_PRINTER_IP_ADDRESS?.split(',');
      if (list?.length > 0) {
        const tempObj = list.map((prop) => {
          return {
            value: prop,
            label: prop,
          };
        });
        setRemotePrinterIpAddrList(tempObj);
      }
    }
  }, []);
  const handleViewHistory = () => {
    setShowViewHistory(true);
    setKeyValue({ USER_ID: logInUser });
  };
  return (
    <div className="tBillPanel custom-check">
      <div className="panel tBillPanel-space pb-0">
        <DisplaySuccessMessages successMessages={sucessMessage} />
        <DisplayErrorMessages errorMessages={errorMessage} />
        <CustomSeparator parent1="System" parent2="User Default" />
        <div className="panel mb-3">
          <Dialog
            open={open}
            onClose={handleClose}
            className="multiGroupDialog custom-dialog-box dialog-420"
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
          >
            <DialogContent>
              <div className="custom-panel">
                <div
                  className="panel-header"
                  style={{ cursor: 'move' }}
                  id="draggable-dialog-title"
                >
                  <span className="float-left"> Cancel </span>
                  <span
                    className="float-right"
                    onClick={handleClose}
                    role="button"
                    tabIndex={0}
                    onKeyDown={handleClose}
                  >
                    <i className="fa fa-times-circle" aria-hidden="true" />
                  </span>

                  <div className="clearfix" />
                </div>
                <div className="text-center modal-alignment">
                  <DialogContentText style={{ color: 'black' }}>
                    There are unsaved changes. Do you want to continue?
                  </DialogContentText>
                </div>
              </div>
            </DialogContent>
            <DialogActions>
              <div className="btn-wrapper my-2">
                <Button
                  onClick={onCancel}
                  className="btn btn-success btn-search mr-2"
                >
                  <SVGComponent iconName="Icon_awesome-check-circle" />
                  Yes
                </Button>
                <Button
                  onClick={handleClose}
                  className="btn btn-cancel btn-primary mr-2"
                  color="primary"
                  autoFocus
                >
                  <SVGComponent iconName="Icon-cancel" />
                  No
                </Button>
              </div>
            </DialogActions>
          </Dialog>

          <Dialog
            open={openSave.open && openSave.cond === 'saveWarningCheckPayee'}
            onClose={handleCloseSave}
            className="multiGroupDialog custom-dialog-box dialog-420"
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
          >
            <DialogContent>
              <div className="custom-panel">
                <div
                  className="panel-header"
                  style={{ cursor: 'move' }}
                  id="draggable-dialog-title"
                >
                  <span className="float-left"> Warning </span>
                  <span
                    className="float-right"
                    onClick={handleClose}
                    role="button"
                    tabIndex={0}
                    onKeyDown={handleClose}
                  >
                    <i className="fa fa-times-circle" aria-hidden="true" />
                  </span>

                  <div className="clearfix" />
                </div>
                <div className="text-center modal-alignment">
                  <DialogContentText style={{ color: 'black' }}>
                    Warning! The selected Check Payee does not agree with the
                    current Rebate Program. Are you sure you want to save the
                    conflicting data?
                  </DialogContentText>
                </div>
              </div>
            </DialogContent>
            <DialogActions>
              <div className="btn-wrapper my-2">
                <Button
                  onClick={onSave}
                  className="btn btn-success btn-search mr-2"
                >
                  <SVGComponent iconName="Icon_awesome-check-circle" />
                  Yes
                </Button>
                <Button
                  onClick={handleCloseSave}
                  className="btn btn-cancel btn-primary mr-2"
                  color="primary"
                  autoFocus
                >
                  <SVGComponent iconName="Icon-cancel" />
                  No
                </Button>
              </div>
            </DialogActions>
          </Dialog>

          <Dialog
            open={openSave.open && openSave.cond === 'saveWarning'}
            onClose={handleClose}
            className="multiGroupDialog custom-dialog-box dialog-420"
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
          >
            <DialogContent>
              <div className="custom-panel">
                <div className="panel-header">
                  <span className="float-left"> Save </span>
                  <span
                    className="float-right"
                    onClick={handleCloseSave}
                    onKeyDown={handleCloseSave}
                    role="button"
                    tabIndex="0"
                  >
                    <i className="fa fa-times-circle" aria-hidden="true" />
                  </span>

                  <div className="clearfix" />
                </div>
                <div className="text-center modal-alignment">
                  <DialogContentText style={{ color: 'black' }}>
                    Are you sure you want to Save your changes? To revert
                    changes, click on Cancel
                  </DialogContentText>
                </div>
              </div>
            </DialogContent>

            <DialogActions>
              <div className="btn-wrapper my-2">
                <Button
                  onClick={onSave}
                  className="btn btn-success btn-search mr-2"
                >
                  <SVGComponent iconName="Icon_awesome-check-circle" />
                  Yes
                </Button>
                <Button
                  onClick={handleCloseSave}
                  className="btn btn-cancel btn-primary mr-2"
                  color="primary"
                  autoFocus
                >
                  <SVGComponent iconName="Icon-cancel" />
                  No
                </Button>
              </div>
            </DialogActions>
          </Dialog>

          <div className="btn-wrapper mt-3 mb-3">
            <div className="float-right mt-3 mb-3 hide-on-print">
              <Button
                className="btn btn-success btn-save"
                onClick={handleClickOpenSave}
                disabled={!isUserChangedValue}
              >
                <SVGComponent iconName="Icon-awesome-save" />
                Save
              </Button>
              <Button
                className="btn btn-cancel"
                onClick={handleClickOpenCancel}
                disabled={!isUserChangedValue}
              >
                <SVGComponent iconName="Icon-cancel" />
                Cancel
              </Button>
            </div>
          </div>
          <div className="btn-wrapper mt-3 mb-3">
            <div className="float-right mt-3 mb-3 hide-on-print">
              <div className="d-flex align-items-center justify-content-end th-icon-group mt-2">
                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip id="history-tooltip">View History</Tooltip>}
                >
                  <div
                    className="th-icon ic-history"
                    role="button"
                    onClick={() => handleViewHistory()}
                    tabIndex="0"
                    onKeyPress={() => handleViewHistory()}
                  >
                    {' '}
                    <span className="ic-title"> History </span>
                  </div>
                </OverlayTrigger>
              </div>
            </div>
          </div>

          <div className="clearfix" />

          <div className="row">
            <div className="col-sm-4">
              <fieldset className="custom-fieldset">
                <legend>Plan Type:</legend>
                <div className="form-wrapper p-0 mt-2">
                  <div className="mui-custom-form no-margin radio-box min-md ">
                    <div className="sub-radio no-margin">
                      <Radio
                        id="Medicaid"
                        value="FD"
                        style={{ height: '13px', width: '13px' }}
                        checked={values.planTypeCd === 'FD'}
                        onChange={(e) => onChangeValuesHandler(e, 'planTypeCd')}
                      />
                      <span className="text-black sub-label" id="Approved">
                        <label
                          className="label-margin"
                          htmlFor="Medicaid"
                          id="med plan"
                        >
                          Medicaid
                        </label>
                      </span>{' '}
                    </div>
                  </div>
                  <div className="mui-custom-form no-margin radio-box min-md ">
                    <div className="sub-radio no-margin">
                      <Radio
                        id="Commercial"
                        value="COMM"
                        style={{ height: '13px', width: '13px' }}
                        checked={values.planTypeCd === 'COMM'}
                        onChange={(e) => onChangeValuesHandler(e, 'planTypeCd')}
                      />
                      <span className="text-black sub-label">
                        <label className="label-margin" htmlFor="Commercial">
                          Commercial
                        </label>
                      </span>{' '}
                    </div>
                  </div>
                  <div className="mui-custom-form no-margin radio-box min-md ">
                    <div className="sub-radio no-margin">
                      <Radio
                        id="State"
                        value="ST"
                        style={{ height: '13px', width: '13px' }}
                        checked={values.planTypeCd === 'ST'}
                        onChange={(e) => onChangeValuesHandler(e, 'planTypeCd')}
                      />
                      <span className="text-black sub-label">
                        <label className="label-margin" htmlFor="State">
                          State
                        </label>
                      </span>{' '}
                    </div>
                  </div>
                  <div className="mui-custom-form no-margin radio-box min-md ">
                    <div className="sub-radio no-margin">
                      <Radio
                        id="Supplemental"
                        value="SUPP"
                        style={{ height: '13px', width: '13px' }}
                        checked={values.planTypeCd === 'SUPP'}
                        onChange={(e) => onChangeValuesHandler(e, 'planTypeCd')}
                      />
                      <span className="text-black sub-label">
                        <label className="label-margin" htmlFor="Supplemental">
                          Supplemental
                        </label>
                      </span>{' '}
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
            <div className="col-sm-4">
              <fieldset className="custom-fieldset">
                <legend className="same-font-family" id="rebateProgramLabel">
                  Rebate Program
                </legend>
                <div className="form-wrapper p-0">
                  <div className="mui-custom-form with-select field-xl no-lbl">
                    <TextField
                      id="RebateProg"
                      fullWidth
                      select
                      placeholder=""
                      inputProps={{
                        maxlength: 11,
                        'aria-labelledby': 'rebateProgramLabel',
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      aria-label="Rebate Program"
                      value={values.rebateProgramCd}
                      onChange={(e) =>
                        onChangeValuesHandler(e, 'rebateProgramCd')
                      }
                    >
                      <MenuItem
                        key=""
                        value="-1"
                        className="frr-dropdown-blank-item"
                      />
                      {rebateProgramCode?.length > 0
                        ? rebateProgramCode.map((item) => {
                            return (
                              <MenuItem
                                key={item.rebateProgramCd}
                                value={item.rebateProgramCd}
                                className="frr-logcheck-dropdown-item"
                              >
                                {item.rebateProgramCd} {'|'} {item.shortDescr}
                              </MenuItem>
                            );
                          })
                        : null}
                    </TextField>
                  </div>
                </div>
              </fieldset>
            </div>
            <div className="col-sm-4">
              <fieldset className="custom-fieldset">
                <legend className="same-font-family" id="checkPayeeLAbel">
                  Check Payee
                </legend>
                <div className="form-wrapper p-0">
                  <div className="mui-custom-form with-select field-xl no-lbl">
                    <TextField
                      id="standard-reason-code"
                      fullWidth
                      select
                      placeholder=""
                      inputProps={{
                        maxlength: 11,
                        'aria-labelledby': 'checkPayeeLAbel',
                      }}
                      InputLabelProps={{
                        shrink: true,
                        'aria-label': 'checkPayeeLAbel',
                      }}
                      value={values.checkPayeeCd}
                      onChange={(e) => onChangeValuesHandler(e, 'checkPayeeCd')}
                    >
                      <MenuItem
                        key=""
                        value="-1"
                        className="frr-dropdown-blank-item"
                      />
                      {checkPayeeCode?.length > 0
                        ? checkPayeeCode.map((item) => {
                            return (
                              <MenuItem
                                selected
                                key={item.codeValueID.codeValue}
                                value={item.codeValueID.codeValue}
                                className="frr-logcheck-dropdown-item"
                              >
                                {item.codeValueID.codeValue}
                                {'|'} {item.longDescription}
                              </MenuItem>
                            );
                          })
                        : null}
                    </TextField>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-4">
              <fieldset className="custom-fieldset">
                <legend>NDC Select Mode:</legend>
                <div className="form-wrapper p-0 mt-2">
                  <div className="mui-custom-form input-md field-xl">
                    <div className="sub-radio no-margin">
                      <Radio
                        id="NDC"
                        value="NDC"
                        checked={values.defNdcSelectModeCd === 'NDC'}
                        onChange={(e) =>
                          onChangeValuesHandler(e, 'defNdcSelectModeCd')
                        }
                      />
                      <span className="text-black sub-label">
                        <label className="label-margin" htmlFor="NDC">
                          NDC
                        </label>
                      </span>{' '}
                    </div>
                  </div>
                  <div className="mui-custom-form input-md field-xl">
                    <div className="sub-radio no-margin">
                      <Radio
                        id="Name"
                        value="NAME"
                        checked={values.defNdcSelectModeCd === 'NAME'}
                        onChange={(e) =>
                          onChangeValuesHandler(e, 'defNdcSelectModeCd')
                        }
                      />
                      <span className="text-black sub-label">
                        <label className="label-margin" htmlFor="Name">
                          Name
                        </label>
                      </span>{' '}
                    </div>
                  </div>
                  <div className="mui-custom-form input-md field-xl">
                    <div className="sub-radio no-margin">
                      <Radio
                        id="Labeler"
                        value="LABELER"
                        checked={values.defNdcSelectModeCd === 'LABELER'}
                        onChange={(e) =>
                          onChangeValuesHandler(e, 'defNdcSelectModeCd')
                        }
                      />
                      <span className="text-black sub-label">
                        <label className="label-margin" htmlFor="Labeler">
                          Labeler
                        </label>
                      </span>{' '}
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
            <div className="col-sm-4">
              <fieldset className="custom-fieldset">
                <legend>Default Report Quarter Option:</legend>
                <div className="form-wrapper p-0 mt-2">
                  <div className="mui-custom-form input-md field-xl">
                    <div className="sub-radio no-margin">
                      <Radio
                        id="DRAMS_Invoice_Start_Quarter"
                        value="D"
                        onChange={(e) =>
                          onChangeValuesHandler(e, 'defRptQtrSelectCd')
                        }
                        checked={values.defRptQtrSelectCd === 'D'}
                      />
                      <span className="text-black sub-label">
                        <label
                          className="label-margin"
                          htmlFor="DRAMS_Invoice_Start_Quarter"
                        >
                          DRAMS Invoice Start Quarter
                        </label>
                      </span>{' '}
                    </div>
                  </div>
                  <div className="mui-custom-form input-md field-xl">
                    <div className="sub-radio no-margin">
                      <Radio
                        id="Earliest_Quarter_for_Drug_Details"
                        value="E"
                        onChange={(e) =>
                          onChangeValuesHandler(e, 'defRptQtrSelectCd')
                        }
                        checked={values.defRptQtrSelectCd === 'E'}
                      />
                      <span className="text-black sub-label">
                        <label
                          className="label-margin"
                          htmlFor="Earliest_Quarter_for_Drug_Details"
                        >
                          Earliest Quarter for Drug Details
                        </label>
                      </span>{' '}
                    </div>
                  </div>
                  <div className="mui-custom-form input-md field-xl">
                    <div className="sub-radio no-margin">
                      <Radio
                        id="All"
                        value="A"
                        onChange={(e) =>
                          onChangeValuesHandler(e, 'defRptQtrSelectCd')
                        }
                        checked={values.defRptQtrSelectCd === 'A'}
                      />
                      <span className="text-black sub-label">
                        <label className="label-margin" htmlFor="All">
                          All
                        </label>
                      </span>{' '}
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
            <div className="col-sm-4">
              <fieldset className="custom-fieldset">
                <legend>Default Invoice Select Mode:</legend>
                <div className="form-wrapper p-0 mt-2">
                  <div className="mui-custom-form input-md field-xl">
                    <div className="sub-radio no-margin">
                      <Radio
                        id="PQM"
                        value="PQM"
                        style={{ height: '13px', width: '13px' }}
                        onChange={(e) =>
                          onChangeValuesHandler(e, 'defInvoiceSelectModeCd')
                        }
                        checked={values.defInvoiceSelectModeCd === 'PQM'}
                      />
                      <span className="text-black sub-label">
                        <label className="label-margin" htmlFor="PQM">
                          Program, Quarter, Manufacturer
                        </label>
                      </span>{' '}
                    </div>
                  </div>
                  <div className="mui-custom-form no-margin radio-box min-md ">
                    <div className="sub-radio no-margin">
                      <Radio
                        id="Invoice_Number"
                        value="IN"
                        style={{ height: '13px', width: '13px' }}
                        onChange={(e) =>
                          onChangeValuesHandler(e, 'defInvoiceSelectModeCd')
                        }
                        checked={values.defInvoiceSelectModeCd === 'IN'}
                      />
                      <span className="text-black sub-label">
                        <label
                          className="label-margin"
                          htmlFor="Invoice_Number"
                        >
                          Invoice Number
                        </label>
                      </span>{' '}
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-4">
              <fieldset className="custom-fieldset">
                <legend>Quarter A/R Invoice Balance:</legend>
                <div className="form-wrapper vertical-wrapper">
                  <div className="mui-custom-form no-margin min-md">
                    <div className="sub-radio text-black sub-label">
                      <FormControlLabel
                        control={<Checkbox color="primary" />}
                        label="Balance Due"
                        value={values.dispBalanceDueInvInd}
                        onChange={() =>
                          onChangeValuesHandler(
                            values.dispBalanceDueInvInd,
                            'dispBalanceDueInvInd',
                            true
                          )
                        }
                        checked={
                          values.dispBalanceDueInvInd ===
                          CHECK_BOX_VALUE_TO_BE_CHECKED
                        }
                      />
                    </div>
                  </div>
                  <div className="mui-custom-form no-margin min-md">
                    <div className="sub-radio text-black sub-label">
                      <FormControlLabel
                        control={<Checkbox color="primary" />}
                        label="Overridden"
                        value={values.dispOverriddenInvInd}
                        onChange={() =>
                          onChangeValuesHandler(
                            values.dispOverriddenInvInd,
                            'dispOverriddenInvInd',
                            true
                          )
                        }
                        checked={
                          values.dispOverriddenInvInd ===
                          CHECK_BOX_VALUE_TO_BE_CHECKED
                        }
                      />
                    </div>
                  </div>
                  <div className="mui-custom-form no-margin min-md">
                    <div className="sub-radio text-black sub-label">
                      <FormControlLabel
                        control={<Checkbox color="primary" />}
                        label="Paid In Full"
                        value={values.dispPaidInFullInvInd}
                        onChange={() =>
                          onChangeValuesHandler(
                            values.dispPaidInFullInvInd,
                            'dispPaidInFullInvInd',
                            true
                          )
                        }
                        checked={
                          values.dispPaidInFullInvInd ===
                          CHECK_BOX_VALUE_TO_BE_CHECKED
                        }
                      />
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
            <div className="col-sm-4">
              <fieldset className="custom-fieldset">
                <legend>A/R NDC Balance Defaults:</legend>
                <div className="form-wrapper vertical-wrapper">
                  <div className="mui-custom-form no-margin min-md">
                    <div className="sub-radio text-black sub-label">
                      <FormControlLabel
                        control={<Checkbox color="primary" />}
                        label="Balance Due"
                        value={values.dispBalanceDueNdcInd}
                        onChange={() =>
                          onChangeValuesHandler(
                            values.dispBalanceDueNdcInd,
                            'dispBalanceDueNdcInd',
                            true
                          )
                        }
                        checked={
                          values.dispBalanceDueNdcInd ===
                          CHECK_BOX_VALUE_TO_BE_CHECKED
                        }
                      />
                    </div>
                  </div>
                  <div className="mui-custom-form no-margin min-md">
                    <div className="sub-radio text-black sub-label">
                      <FormControlLabel
                        control={<Checkbox color="primary" />}
                        label="Overridden"
                        value={values.dispOverriddenNdcInd}
                        onChange={() =>
                          onChangeValuesHandler(
                            values.dispOverriddenNdcInd,
                            'dispOverriddenNdcInd',
                            true
                          )
                        }
                        checked={
                          values.dispOverriddenNdcInd ===
                          CHECK_BOX_VALUE_TO_BE_CHECKED
                        }
                      />
                    </div>
                  </div>
                  <div className="mui-custom-form no-margin min-md">
                    <div className="sub-radio text-black sub-label">
                      <FormControlLabel
                        control={<Checkbox color="primary" />}
                        label="Paid In Full"
                        value={values.dispPaidInFullNdcInd}
                        onChange={() =>
                          onChangeValuesHandler(
                            values.dispPaidInFullNdcInd,
                            'dispPaidInFullNdcInd',
                            true
                          )
                        }
                        checked={
                          values.dispPaidInFullNdcInd ===
                          CHECK_BOX_VALUE_TO_BE_CHECKED
                        }
                      />
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
            <div className="col-sm-4">
              <fieldset className="custom-fieldset">
                <legend>A/R Activity Defaults:</legend>
                <div className="form-wrapper vertical-wrapper">
                  <div className="mui-custom-form no-margin min-md">
                    <div className="sub-radio text-black sub-label">
                      <FormControlLabel
                        control={<Checkbox color="primary" />}
                        label="View Principal Activity"
                        value={values.viewPmtActInd}
                        onChange={() =>
                          onChangeValuesHandler(
                            values.viewPmtActInd,
                            'viewPmtActInd',
                            true
                          )
                        }
                        checked={
                          values.viewPmtActInd === CHECK_BOX_VALUE_TO_BE_CHECKED
                        }
                      />
                    </div>
                  </div>
                  <div className="mui-custom-form no-margin min-md">
                    <div className="sub-radio text-black sub-label">
                      <FormControlLabel
                        control={<Checkbox color="primary" />}
                        label="View Interest Activity"
                        value={values.viewIntActInd}
                        onChange={() =>
                          onChangeValuesHandler(
                            values.viewIntActInd,
                            'viewIntActInd',
                            true
                          )
                        }
                        checked={values.viewIntActInd}
                      />
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
          {hasAccessbyRole && (
            <div className="row">
              <div className="col-sm-4">
                <fieldset className="custom-fieldset">
                  <legend className="same-font-family" id="clientLabel">
                    Client
                  </legend>
                  <div className="form-wrapper p-0">
                    <div className="mui-custom-form with-select field-xl no-lbl">
                      <TextField
                        id="standard-reason-code"
                        fullWidth
                        select
                        placeholder=""
                        inputProps={{
                          maxlength: 11,
                          'aria-labelledby': 'clientLabel',
                        }}
                        InputLabelProps={{
                          shrink: true,
                          'aria-label': 'clientLabel',
                        }}
                        value={values.clientId}
                        onChange={(e) => onChangeValuesHandler(e, 'clientId')}
                      >
                        <MenuItem
                          key=""
                          value="-1"
                          className="frr-dropdown-blank-item"
                        />
                        {clientCode &&
                        clientCode.length &&
                        clientCode.length > 0
                          ? clientCode.map((item) => {
                              return (
                                <MenuItem
                                  selected
                                  key={item.cgpId.clientId}
                                  value={item.cgpId.clientId}
                                  className="frr-logcheck-dropdown-item"
                                >
                                  {`${
                                    item.clientName
                                      ? `${item.cgpId.clientId} | ${item.clientName}`
                                      : `${item.cgpId.clientId}`
                                  }`}
                                </MenuItem>
                              );
                            })
                          : null}
                      </TextField>
                    </div>
                  </div>
                </fieldset>
              </div>
              <div className="col-sm-4">
                <fieldset className="custom-fieldset">
                  <legend className="same-font-family" id="groupLabel">
                    Group
                  </legend>
                  <div className="form-wrapper p-0">
                    <div className="mui-custom-form with-select field-xl no-lbl">
                      <TextField
                        id="standard-reason-code"
                        fullWidth
                        select
                        placeholder=""
                        inputProps={{
                          maxlength: 11,
                          'aria-labelledby': 'groupLabel',
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={values.groupId}
                        onChange={(e) => onChangeValuesHandler(e, 'groupId')}
                      >
                        <MenuItem
                          key=""
                          value="-1"
                          className="frr-dropdown-blank-item"
                        />
                        {groupCode && groupCode.length && groupCode.length > 0
                          ? groupCode.map((item) => {
                              return (
                                <MenuItem
                                  key={item.clientGroupId.groupId}
                                  value={item.clientGroupId.groupId}
                                  className="frr-logcheck-dropdown-item"
                                >
                                  {`${
                                    item.groupName
                                      ? `${item.clientGroupId.groupId} | ${item.groupName}`
                                      : `${item.clientGroupId.groupId}`
                                  }`}
                                </MenuItem>
                              );
                            })
                          : null}
                      </TextField>
                    </div>
                  </div>
                </fieldset>
              </div>
              <div className="col-sm-4">
                <fieldset className="custom-fieldset">
                  <legend className="same-font-family" id="planLabel">
                    Plan
                  </legend>
                  <div className="form-wrapper p-0">
                    <div className="mui-custom-form with-select field-xl no-lbl">
                      <TextField
                        id="standard-reason-code"
                        fullWidth
                        select
                        placeholder=""
                        inputProps={{
                          maxlength: 11,
                          'aria-labelledby': 'planLabel',
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={values.planId}
                        onChange={(e) => onChangeValuesHandler(e, 'planId')}
                      >
                        <MenuItem
                          key=""
                          value=""
                          className="frr-dropdown-blank-item"
                        />
                        {planCode && planCode.length && planCode.length > 0
                          ? planCode.map((item) => {
                              return (
                                <MenuItem
                                  selected
                                  key={item.cgpId.clientId}
                                  value={item.cgpId.planId}
                                  className="frr-logcheck-dropdown-item"
                                >
                                  {`${item.cgpId.planId} | ${item.planName}`}
                                </MenuItem>
                              );
                            })
                          : null}
                      </TextField>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
          )}

          <div className="row">
            <div className="col-sm-4">
              <fieldset className="custom-fieldset">
                <legend className="same-font-family" id="groupLabel">
                  Remote Printer Selection
                </legend>
                <div className="form-wrapper p-0">
                  <div className="mui-custom-form with-select field-xl no-lbl">
                    <TextField
                      id="standard-reason-code"
                      fullWidth
                      select
                      placeholder=""
                      inputProps={{
                        maxlength: 11,
                        'aria-labelledby': 'groupLabel',
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={values?.printerIpAddrs}
                      onChange={(e) =>
                        onChangeValuesHandler(e, 'printerIpAddrs')
                      }
                    >
                      <MenuItem
                        key=""
                        value="-1"
                        className="frr-dropdown-blank-item"
                      />
                      {remotePrinterIpAddrList &&
                      remotePrinterIpAddrList.length > 0
                        ? remotePrinterIpAddrList.map((item, index) => {
                            return (
                              <MenuItem
                                key={index}
                                value={item.value}
                                className="frr-logcheck-dropdown-item"
                              >
                                {item.label}
                              </MenuItem>
                            );
                          })
                        : null}
                    </TextField>
                  </div>
                </div>
              </fieldset>
            </div>
            <div className="col-sm-7">
              <div className="col-sm-6">
                <div className="mui-custom-form input-md override-width-100">
                  <div className="sub-radio">
                    <FormControlLabel
                      control={<Checkbox color="primary" />}
                      label="Default Units Modified for Dispute Resolution"
                      value={values.defDisputeResolutionInd}
                      onChange={() =>
                        onChangeValuesHandler(
                          values.defDisputeResolutionInd,
                          'defDisputeResolutionInd',
                          true
                        )
                      }
                      checked={values.defDisputeResolutionInd === 1}
                    />
                  </div>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="mui-custom-form input-md override-width-100">
                  <div className="sub-radio">
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          checked={is508NotReq}
                          onChange={(e) => {
                            dispatch(
                              dispatchSetOverride508Compliance(e.target.checked)
                            );
                          }}
                        />
                      }
                      label="Override 508 Compliance"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {showViewHistory && (
            <ViewHistoryComponent
              setShowViewHistory={setShowViewHistory}
              tableName="USER_DEFAULT"
              keyValue={keyValue}
              isSpinner={false}
            />
          )}
          <Footer print />
        </div>
      </div>
    </div>
  );
}
export default UserDefaultForm;
